import bodyScroll from 'body-scroll-toggle';

const Modal = () => {
    if (document.querySelector('[data-cModal]')) {
        const modals = document.querySelectorAll('[data-cModal]');
        const modalHandlers = document.querySelectorAll('[data-cModal-handlers]');

        const hideAllItems = modal => {
            const allItems = modal.querySelectorAll('[data-cmodal-id]');
            allItems.forEach(item => {
                item.classList.remove('is-chosen');
            });
        }

        const openModal = modal => {
            bodyScroll.disable()
            modal.classList.add('modal-opened');
        };

        const closeModal = modal => {
            bodyScroll.enable()
            modal.classList.remove('modal-opened');
            hideAllItems(modal);
        };

        const checkIfLast = (modal, nextItem) => {
            if (!nextItem) return;

            hideAllItems(modal);
            nextItem.classList.add('is-chosen');
        }

        const switchSlide = (modal, target, leftBtn, rightBtn) => {
            const activeItem = modal.querySelector('.is-chosen');

            switch (target) {
                case leftBtn:
                    checkIfLast(modal, activeItem.previousElementSibling);
                    break;

                case rightBtn:
                    checkIfLast(modal, activeItem.nextElementSibling);
                    break;
            }
        };

        modalHandlers.forEach(handler => {
            handler.addEventListener('click', e => {
                modals.forEach(modal => {
                    if (modal.dataset.cmodal !== handler.dataset.cmodalHandlers) return;

                    if (e.target === handler || e.target.nodeName === 'UL') return;

                    const selectedItem = modal.querySelector(`[data-cmodal-id~="${e.target.closest("[data-cmodal-id]").dataset.cmodalId}"]`);

                    if (!selectedItem) return;

                    hideAllItems(modal)
                    selectedItem.classList.add('is-chosen');
                    openModal(modal);
                })
            })
        })

        modals.forEach(modal => {
            modal.addEventListener('click', e => {
                const closeBtn = modal.querySelector('.modal__close-btn');
                const rightBtn = modal.querySelector('.modal-move__btn--right');
                const leftBtn = modal.querySelector('.modal-move__btn--left');

                if (e.target === modal) {
                    closeModal(modal);
                };

                if (e.target === closeBtn) {
                    closeModal(e.target.closest('.modal'));
                }

                if (e.target !== rightBtn && e.target !== leftBtn) {
                    return;
                }

                switchSlide(modal, e.target, leftBtn, rightBtn);
            })
        });
    }
}

export default Modal;